export default {
  notFound: 'منو یافت نشد',
  MenuUpdated: 'منو به روز رسانی شد',
  OpenIn: 'باز شدن در',
  SamePage: 'همان صفحه',
  NewPage: 'صفحه جدید',
  CssClass: 'کلاس CSS',
  Component: 'کامپوننت',
  Everyone: 'همه',
  Authenticated: 'فقط اعضا',
  Unauthenticated: 'فقط غیر اعضا',
  EnterTitleOrIcon: 'هر آیتم باید حداقل عنوان یا آیکون داشته باشد'
}
